import { blue } from "@mui/material/colors";
import React from "react";
import { LetterIcon } from "./LetterIcon";

export const DeclarerIcon = () => {
  return <LetterIcon color={blue[500]} title="Declarer" />;
};
